import { makeAutoObservable } from 'mobx'
import appConstants from './../../constants/appConstants'
import AuthService from './../services/Auth.service'
import WorkerBuilder from '../utilities/workerBuilder.class'
import { activityWorker } from '../workers/activityWorker'

const SESSION_LOGOUT = appConstants.session_inactive_logout
const SESSION_WARNING = appConstants.session_inactive_warning
const TIME_PERIOD_MS = SESSION_LOGOUT * 1000 + SESSION_WARNING
const STORAGE_KEY_LAST_ACTIVITY = 'recorded_at'
const STORAGE_KEY_EXPIRES_AT = 'session_expires_at'

class ActivityStore {
  showWarningModal = false
  remaining = SESSION_LOGOUT
  worker
  isTrainingModalOpen = false

  constructor() {
    makeAutoObservable(this)
    this.worker = new WorkerBuilder(activityWorker)
    this.worker.postMessage({
      type: 'init',
      SESSION_LOGOUT,
      SESSION_WARNING,
    })
    this.worker.onmessage = event => {
      switch (event.data.type) {
        case 'logout':
          this.logout()
          break
        case 'showWarningModal':
          this.showWarningModal = event.data.showWarningModal
          break
        case 'updateRemaining':
          this.remaining = event.data.remaining
          break
        default:
          break
      }
    }
  }

  logout = () => {
    this.setTimestamp(true)
    AuthService.logout()
    window.location.href = 'login'
  }

  cancelWarning = () => {
    this.setTimestamp()
    this.worker.postMessage({
      type: 'cancelWarning',
    })
  }

  recordRequest = async () => {
    this.setTimestamp()
    this.worker.postMessage({
      type: 'restartTimer',
      token: AuthService.getToken(),
    })
  }

  checkActivity = () => {
    if (this.isTrainingModalOpen) return

    const now = Date.now()
    const expiresAt = this.getExpiresAt()
    if (expiresAt != null && now > expiresAt) {
      this.logout()
    }
  }

  getExpiresAt = () => {
    const stored = window.localStorage.getItem(STORAGE_KEY_EXPIRES_AT)
    if (stored != null && stored !== '') return parseInt(stored, 10)
    const recorded = window.localStorage.getItem(STORAGE_KEY_LAST_ACTIVITY)
    if (recorded != null && recorded !== '') return parseInt(recorded, 10) + TIME_PERIOD_MS
    return null
  }

  pauseTimer = () => {
    this.isTrainingModalOpen = true
    this.worker.postMessage({
      type: 'pauseTimer',
    })
  }

  resumeTimer = () => {
    this.isTrainingModalOpen = false
    this.worker.postMessage({
      type: 'resumeTimer',
    })
  }

  setTimestamp = (clear = false) => {
    if (clear) {
      window.localStorage.removeItem(STORAGE_KEY_LAST_ACTIVITY)
      window.localStorage.removeItem(STORAGE_KEY_EXPIRES_AT)
      return
    }
    const now = Date.now()
    window.localStorage.setItem(STORAGE_KEY_LAST_ACTIVITY, String(now))
    window.localStorage.setItem(STORAGE_KEY_EXPIRES_AT, String(now + TIME_PERIOD_MS))
  }

  getTimestamp = () => {
    return window.localStorage.getItem(STORAGE_KEY_LAST_ACTIVITY)
  }
}

const activityStore = new ActivityStore()

// Make it globally accessible for other components
if (typeof window !== 'undefined') {
  window.ActivityStore = activityStore
}

export default activityStore
